module.exports = __webpack_public_path__ + "static/scale-model-of-stranahan's-colorado-whiskey-in-lakewood-colorado-0b73217b45e64b312c281484daf25dfd.png";